/**
 * SMSWiser sending-tool capability flags (drives UI gating: API vs deprecated scraping).
 * For Media Devoted | Created By Ciro Autiero
 */

import { useQuery } from '@tanstack/react-query';

import api from '@/services/api';

export interface ToolCapabilities {
  provider: string;
  capabilities: string[];
  supportsEditDrop: boolean;
  supportsStopDrop: boolean;
  /** True only when the deprecated Puppeteer scraping path is enabled. */
  legacyScrapingEnabled: boolean;
}

export function useToolCapabilities() {
  return useQuery({
    queryKey: ['smswiser', 'tool-stats', 'capabilities'],
    queryFn: async () => {
      const res = await api.get<{ data: ToolCapabilities }>(
        '/smswiser/tool-stats/capabilities',
      );
      return res.data.data;
    },
    staleTime: 60_000,
  });
}
